export const initialState = {
    token: null,
    isLoading: false,
    error: null,
};
